import { render, staticRenderFns } from "./quan-item.vue?vue&type=template&id=3b5aff67&scoped=true"
import script from "./quan-item.vue?vue&type=script&lang=js"
export * from "./quan-item.vue?vue&type=script&lang=js"
import style0 from "./quan-item.vue?vue&type=style&index=0&id=3b5aff67&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5aff67",
  null
  
)

export default component.exports